import { gql } from '@apollo/client';

export const GET_ONBOARDING_OPTION_STAGES = gql`
  query GetOnboardingOptionStages {
    vm {
      onboardingOptionStages {
        optionType
        customTitle
        customDescription
        isRequired
        taskStage {
          taskStageId
          name
          order
        }
      }
    }
  }
`;

export const ONBOARDING_OPTION_STAGE_FRAGMENT = gql`
  fragment OnboardingOptionStageFragment on VOLUNTEER_OnboardingOptionStageType {
    optionType
    customTitle
    customDescription
    taskStage {
      taskStageId
      name
      order
    }
  }
`;